// extracted by mini-css-extract-plugin
export default {"title":"articlePageUser_title__dkjpo","articlecontent":"articlePageUser_articlecontent__sKtoq","article-content":"articlePageUser_article-content__lnwmV"};